import { appConsts } from "../common/constants/app_consts"
import { appNums } from "../common/nums/app_nums"
import { guid } from "./random_utils"

const { regExEmailValidation, regEverythingButDigits } = appConsts
const { MIN_ONBOARDING_TEAM_FIELDS } = appNums

export const checkIfAllFalsyValues = (patchMeta, key="") =>
    Object.keys(patchMeta).filter(item => {
        const value = !key ?  patchMeta[item] : patchMeta[item][key]
        return value !== ""
    }).length === 0

export const getCompanyTeamId = (memberships, personalTeamId) =>
    // company team id is the non-personal team
    Object.keys(memberships).find(
        membershipId => membershipId !== personalTeamId,
    )

export const updateBaseMapField = (fields, value, id, type) => {
    return {
        ...fields,
        [id]: {
            ...fields[id],
            [type]: value,
        },
    }
}

export const renderValidationClass = isValid =>
    !isValid && "invalid-email-input"

export const parseFieldsToTextArea = fields => {
    return parseToTextArea(fields, "email")
}

export const checkIfEmailIsValid = (email, regEx) => !email || regEx.test(email)

export const validateFields = fields =>
    Object.keys(fields).filter(field => !fields[field].isValid).length === 0

export const stringifyInvalidEmails = fields => {
    const invalidIds = Object.keys(fields)
    const invalidEmails = invalidIds.reduce((acc, id) => {
        const { email, isValid } = fields[id]
        return isValid || !email ? acc : [...acc, email]
    }, [])
    return invalidEmails.join(", ")
}

export const parseTextAreaToFields = (textAreaContent, useMin = true) => {
    const emails = splitStringOnNewLineOrComma(textAreaContent)
    const trimmedEmails = emails.map(email => email.trim())
    const fields = trimmedEmails.reduce((acc, email) => {
        const id = guid()
        return email === ""
            ? acc
            : {
                ...acc,
                [id]: makeInviteField(
                    email,
                    true,
                    checkIfEmailIsValid(email, regExEmailValidation),
                    id,
                ),
            }
    }, {})

    const distanceFromMin =
        Object.keys(fields).length - MIN_ONBOARDING_TEAM_FIELDS
    return useMin && distanceFromMin < 0
        ? { ...fields, ...generateDefaultInviteFields(distanceFromMin) }
        : fields
}

export const removeEmptyFields = fields => {
    return Object.keys(fields).reduce((acc, fieldId) => {
        const field = fields[fieldId]
        const { email } = field 
        return email === ""
            ? acc
            : { ...acc, [fieldId]: { ...field } }
    }, {})
}

export const generateDefaultInviteFields = number => {
    const value = Math.abs(number)
    const count = Array.apply(null, Array(value))
    return count.reduce((acc, i) => {
        const id = guid()
        return {
            ...acc,
            [id]: makeInviteField("", false, true, id),
        }
    }, {})
}

export const makeInviteField = (
    email = "",
    hasBlurred = false,
    isValid = true,
    newGuid = "",
    fullName = "",
) => {
    const id = newGuid ? newGuid : guid()
    return {
        id,
        email,
        hasBlurred,
        isValid,
        fullName,
    }
}

export const makeTagField = (guid = "", name = "") => {
    const id = guid ? guid : guid()
    return {
        id,
        name,
    }
}

export const parseTagsToTextArea = tags => {
    return parseToTextArea(tags, "name")
}

const parseToTextArea = (fields, key) => {
    const ids = Object.keys(fields)
    if (!ids.length) return ""
    return ids.reduce((acc, id) => {
        const value = fields[id][key]
        return acc === "" ? value : value !== "" ? `${acc}, ${value}` : acc
    }, "")
}

export const parseTextAreaToTags = textAreaContent => {
    if (!textAreaContent) {
        const id = guid()
        return {
            [id]: makeTagField(id, ""),
        }
    }

    const tags = splitStringOnNewLineOrComma(textAreaContent)
    const trimmedTags = tags.map(tag => tag.trim())
    const fields = trimmedTags.reduce((acc, tag) => {
        const id = guid()
        return tag === ""
            ? acc
            : {
                ...acc,
                [id]: makeTagField(id, tag),
            }
    }, {})
    return fields
}

export const renderOutlineClass = (
    verificationCodeLength,
    inputLength,
    index,
) => {
    const isSelectedField = inputLength === index
    const isLastSelectedField =
        verificationCodeLength === inputLength && index === inputLength - 1

    return (isSelectedField || isLastSelectedField) && "display-box-outline"
}

// removes every character except for 0-9 digits
export const parseVerificationCode = input => input.replace(regEverythingButDigits, "")

export const getLocalStorageItem = key => localStorage.getItem(key)

//replaces any newLine with a comma, effectivly splitting string content at commas AND newLine
const splitStringOnNewLineOrComma = (text) => {
    const newLine = /\n/g
    const textNewLineReplaced = text.replace(newLine, ",")

    return textNewLineReplaced.split(",")
}





// WEBPACK FOOTER //
// ./src/util/onboarding_utils.js